// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__0cwBD","root":"index_root__ditRW"};